module.exports = __webpack_public_path__ + "static/media/heringsLOGO_mobile.0975c114.svg";